<template>
  <div>
    <div
      class="drop-down-block-screen"
      v-show="dropDownIsOpen && !canEsc"
    ></div>
    <div
      :class="{
        'button-filter': true,
        'active': dropDownIsOpen,
      }"
      ref="buttonFilter"
      @keydown.esc="onEscPress"
      v-click-outside="onClickOut"
      tabindex="0"
    >
      <button
        @click="onButtonClick"
        :class="{
          'active': dropDownIsOpen,
          'filtered': filter.length
        }"
        role="button-filter"
      >
        <v-icon>{{ icon }}</v-icon>
        {{ title }}
      </button>
      <transition name="fade">
        <div
          class="drop-down"
          v-show="dropDownIsOpen"
          @keydown.esc="onEscPress"
          :style="'width:' + width"
        >
          <h3><v-icon class="color">{{ icon }}</v-icon> {{ title }}</h3>
          <smart-checkbox v-for="(item, key) in items"
            :key="key + '' + checkboxChangesKey"
            :data-vv-name="checkboxName"
            @change="checkboxChanges(key, $event)"
            :checked="!!checkboxValues[key]"
            :label="item.text"
            :title="item.text"
            class="mt-3"
          />
          <div class="buttons">
            <smart-button
              class="ml-2"
              @click="apply"
              :key="'apply-button-'+checkboxChangesKey"
            >Aplicar</smart-button>

            <smart-button
              secondary
              v-if="clearable"
              :disabled="clearDisabled()"
              @click="clear"
              :key="'clear-button-'+checkboxChangesKey"
            >Limpar</smart-button>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'
import { mapActions } from 'vuex';

export default {
  name: 'ButtonFilter',
  components: {},
  props: {
    clearable: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      required: true,
    },
    slug: {
      type: String,
      required: true,
    },
    icon: {
      type: String, // look https://fonts.google.com/icons?selected=Material+Icons
      default: '',
    },
    items: {
      type: Array,
      default: [
        {
          id: 'a',
          text: 'Filtro A',
        },
        {
          id: 'b',
          text: 'Filtro B',
        }
      ],
      required: false,
    },
    width: {
      type: String,
      default: '350px',
    },
  },
  data() {
    return {
      dropDownIsOpen: false,
      checkboxName: 'checkbox-' + (new Date()).toISOString().replace(/\D/g, ''),
      checkboxValues: [],
      checkboxChangesKey: 0,
      filter: [],
      beforeOpenCheckboxChangesKey: [],
      canEsc: true,
    };
  },
  methods: {
    ...mapActions({
      setFilters: 'termImportHistory/setFilters',
    }),
    onButtonClick() {
      this.beforeOpenCheckboxChangesKey = this.checkboxChangesKey;

      if (this.clearDisabled() || this.dropDownIsOpen === false) {
        this.dropDownIsOpen = !this.dropDownIsOpen;
      }
    },
    checkboxChanges(key, value) {
      this.checkboxValues[key] = value;
      this.checkboxChangesKey++;
      this.canEscUpdate();
    },
    onClickOut() {
      return this.onEscPress();
    },
    onEscPress() {
      if (this.canEsc) {
        this.apply();
      }
    },
    clear() {
      this.checkboxValues = this.checkboxValues.map(item => false);
      this.$refs.buttonFilter.focus();
      this.filter = [];
      this.canEsc = true;
      this.emitEventApply();
    },
    clearAll() {
      this.checkboxValues = this.checkboxValues.map(item => false);
      this.setFilters({});
      this.canEsc = true;
      this.apply();
    },
    apply() {
      this.filter = [];
      this.checkboxValues.map((item, i) => {
        if (item) {
          this.filter.push(this.items[i].id);
        }
      });

      if (!this.canEsc) {
        this.emitEventApply();
      }

      this.dropDownIsOpen = false;
    },
    emitEventApply() {
      this.$emit('applied', { slug: this.slug, filter: this.filter });
    },
    clearDisabled() {
      let countChecks = 0;

      this.checkboxValues.map(item => {
        if (item === true) {
          countChecks++;
        }
      });

      return !(countChecks > 0);
    },
    canEscUpdate() {
      this.canEsc = this.clearDisabled() &&
        (
          JSON.stringify(this.filter) === '[]' ||
          this.beforeOpenCheckboxChangesKey === this.checkboxChangesKey
        );
    }
  },
  mounted() {
    this.items.map(() => {
      this.checkboxValues.push(false);
    });
  },
  created() {
    this.$parent.$on('clearall', this.clearAll);
  },
  directives: {
    ClickOutside
  }
}
</script>

<style lang="scss">
.button-filter {
  position: relative;
  z-index: 0;

  &.active {
    z-index: 3;
  }

  &:focus {
    outline: none;
  }

  .buttons {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    flex-direction: row-reverse;

    button[role=button] {
      margin-top: 30px;
      display: flex;
      flex-wrap: wrap;
      flex-direction: row-reverse;
    }
  }

  button[role=button-filter] {
    border: 1px solid $color-ui-gradient-gray;
    border-radius: 4px;
    line-height: 24px;
    padding: 10px 20px;
    margin: 5px;
    display: flex;
    flex-wrap: wrap;
    font-size: $font-size-default;
    color: $color-ui-gray;
    background: white;

    &:hover, &:focus, &.active {
      background: rgba(0,0,0,.025);
      transition: background .3s ease;
      border-color: $color-ui-gray;
      color: $color-ui-gray;
      outline: none;
      .v-icon {
        color: $color-ui-gray;
      }
    }

    &.filtered {
      background: $color-brand-secondary;
      color: white;
      border-color: white;

      i.v-icon {
        color: white;
      }
    }

    .v-icon {
      color: $color-ui-gradient-gray;
      font-size: 24px;
      line-height: 24px;
      margin-right: 5px;
      margin-left: -5px;
    }
  }

  h3 {
    font-weight: 500;
    font-size: 18px;
    display: flex;
    flex-wrap: wrap;
    margin: 5px 0 15px 0;

    .v-icon.color {
      color: $color-ui-success;
      background: rgba(0,0,0,.055);
      padding: 5px;
      border-radius: 100%;
      margin-top: -10px;
      margin-right: 5px;
    }
  }
  .drop-down {
    background: white;
    position: absolute;
    width: 515px;
    min-width: 300px;
    height: auto;
    min-height: 100px;
    box-shadow: 0 5px 5px 5px rgba(0,0,0,.1);
    padding: 20px 20px 40px;
    border-radius: 8px;
    display: flex;
    flex-wrap: wrap;
    z-index: 2;

    label:hover {
      color: black;

      input {
        border-color: black;
      }
    }

    .smart-checkbox__label {
      margin-left: 10px!important;
      font-size: $font-size-default;
      width: 100%;
    }
  }

}

.drop-down-block-screen {
  display: block;
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 2;
  top: 0;
  left: 0;
  cursor: not-allowed;
}
</style>
